import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { CheckboxInput } from "./CheckboxInput";
import { HookFormCheckboxInputProps } from "./CheckboxInput.types";

export const HookFormCheckboxInput = <T extends FieldValues>(
  props: HookFormCheckboxInputProps<T>
): React.ReactElement => {
  const { form, name, rules, onChange, valueMode = "boolean", ...rest } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <CheckboxInput
          {...rest}
          checked={
            valueMode === "string" ? field.value === "true" : !!field.value
          }
          onCheckedChange={(checked) => {
            field.onChange(valueMode === "string" ? String(checked) : checked);
            onChange?.(checked);
          }}
          error={
            fieldState.error?.message ||
            buildErrorMessageForName(form, name) ||
            undefined
          }
        />
      )}
    />
  );
};
